import { GoogleButton } from './containers'

export { GoogleButton }



// WEBPACK FOOTER //
// ./client/Modules/AppAuthPage/index.js